<div class="flex h-full w-full flex-col rounded-lg py-5">
  <!-- Type filters -->
  <div class="mb-4 flex flex-col">
    <!-- Filter buttons -->
    <div class="flex flex-wrap gap-2">
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-primary-500 bg-primary-500 text-neutral-0': selectedTypeFilter() === 'All',
          'text-neutral-700 border-neutral-300 hover:border-neutral-400 bg-neutral-0': selectedTypeFilter() !== 'All',
        }"
        (click)="setTypeFilter('All')"
      >
        Всі
      </button>
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-primary-500 bg-primary-500 text-neutral-0': selectedTypeFilter() === 'Appointment',
          'text-neutral-700 border-neutral-300 hover:border-neutral-400 bg-neutral-0': selectedTypeFilter() !== 'Appointment',
        }"
        (click)="setTypeFilter('Appointment')"
      >
        Консультації
      </button>
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-primary-500 bg-primary-500 text-neutral-0': selectedTypeFilter() === 'Drugs',
          'text-neutral-700 border-neutral-300 hover:border-neutral-400 bg-neutral-0': selectedTypeFilter() !== 'Drugs',
        }"
        (click)="setTypeFilter('Drugs')"
      >
        Ліки
      </button>
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-primary-500 bg-primary-500 text-neutral-0': selectedTypeFilter() === 'InstrumentalDiagnostic',
          'text-neutral-700 border-neutral-300 hover:border-neutral-400 bg-neutral-0': selectedTypeFilter() !== 'InstrumentalDiagnostic',
        }"
        (click)="setTypeFilter('InstrumentalDiagnostic')"
      >
        Діагностика
      </button>
      <button
        class="rounded-full border px-3 py-1 text-sm transition-colors"
        [ngClass]="{
          'border-primary-500 bg-primary-500 text-neutral-0': selectedTypeFilter() === 'LaboratoryService',
          'text-neutral-700 border-neutral-300 hover:border-neutral-400 bg-neutral-0': selectedTypeFilter() !== 'LaboratoryService',
        }"
        (click)="setTypeFilter('LaboratoryService')"
      >
        Лабораторні послуги
      </button>
    </div>
  </div>

  <!-- Prescriptions list -->
  <div class="flex-1 overflow-y-auto overflow-x-hidden">
    @if (loading()) {
      <div class="flex h-32 items-center justify-center">
        <shared-loader></shared-loader>
      </div>
    } @else {
      @if (filteredPrescriptions().length > 0) {
        @for (prescription of filteredPrescriptions(); track prescription.id) {
          <div
            class="mb-4 cursor-pointer rounded-lg bg-neutral-50 p-4 transition-shadow hover:shadow-md"
            [ngClass]="{ 'border-2 border-primary-500 bg-warning-100': highlightedPrescriptionId() === prescription.id }"
            [attr.data-prescription-id]="prescription.id"
          >
            <div class="flex items-start gap-3">
              <div class="flex-1">
                <div class="flex flex-col gap-1">
                  <div class="flex items-start justify-between">
                    <div class="flex flex-col items-start">
                      <prescriptions-icon [prescriptionType]="prescription.type"></prescriptions-icon>
                      <span class="text-neutral-500">{{ prescription.name }}</span>
                    </div>
                    <button
                      class="flex h-8 w-8 items-center justify-center rounded-full bg-neutral-100 shadow-sm hover:bg-neutral-200"
                      [matMenuTriggerFor]="prescriptionActionsMenu"
                      (click)="$event.stopPropagation()"
                      type="button"
                    >
                      <mat-icon
                        class="text-neutral-500"
                      >more_vert</mat-icon>
                    </button>
                    <mat-menu #prescriptionActionsMenu="matMenu">
                      <button
                        mat-menu-item
                        class="flex items-center gap-2"
                        (click)="createAppointment(prescription, $event)"
                      >
                        <mat-icon>event</mat-icon>
                        {{ "Створити візит" }}
                      </button>
                      <button
                        mat-menu-item
                        class="flex items-center gap-2"
                        (click)="bindToExistingAppointment(prescription, $event)"
                      >
                        <mat-icon>link</mat-icon>
                        {{ "Прив'язати до існуючого" }}
                      </button>
                      <button
                        mat-menu-item
                        class="flex items-center gap-2"
                        (click)="navigateToPrescription(prescription, $event)"
                      >
                        <mat-icon>open_in_new</mat-icon>
                        {{ "Переглянути в гарантації" }}
                      </button>
                    </mat-menu>
                  </div>
                  <div class="flex items-center justify-between">
                    <div class="mt-2 flex items-center gap-2">
                      <shared-status
                        [statusValue]="prescription.guaranteeStatus"
                        [statusMessage]="'statuses.guarantationStatuses.' + prescription.guaranteeStatus | translate"
                      ></shared-status>
                      <mat-icon class="text-neutral-400 text-sm">keyboard_double_arrow_right</mat-icon>
                      <shared-status
                        [statusValue]="prescription.planningStatus"
                        [statusMessage]="'status.prescription.planning.' + prescription.planningStatus | translate"
                      ></shared-status>
                    </div>
                    <span class="mt-1 text-xs text-neutral-500">Створено: {{ formatDate(prescription.creationDate, true) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="text-neutral-500 py-8 text-center">
          <p>Немає призначень</p>
        </div>
      }
    }
  </div>
</div>
